import Item from "@/views/model/item/item.vue"; //物料页
// import TitleBlock from '@/views/model/item/titleBlock.vue' //物料页
import Bom from "@/views/model/item/BOM.vue"; //物料页
import ItemChanges from "@/views/model/item/itemChanges.vue"; //物料页
import ItemWhereUsed from "@/views/model/item/itemWhereUsed.vue"; //
// import Relationship from '@/views/model/item/relationship.vue'
import ItemHistory from "@/views/model/item/itemHistory.vue"; //物料页
import Manufacturers from "@/views/model/item/manufacturers.vue"; //制造商页

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

export const ItemPage = {
  path: "/item",
  component: Item,
  meta: {},
  children: [
    {
      path: "/titleBlock",
      component: PageInfo,
      meta: {},
    },
    {
      path: "/bom",
      component: Bom,
      name: "BOM",
      meta: {},
    },
    {
      path: "/itemRelationship",
      component: Relationship,
      meta: {},
    },
    {
      path: "/itemQualityPage",
      component: () => import("@/views/model/item/quality"),
    },
    {
      path: "/itemRelatedTechnology",
      component: () => import("@/views/model/item/itemRelatedTechnology"),
    },
    {
      path: "/itemChanges",
      component: ItemChanges,
      meta: {},
    },
    {
      path: "/itemWhereUsed",
      component: ItemWhereUsed,
      meta: {},
    },
    {
      path: "/itemHistory",
      component: ItemHistory,
      meta: {},
    },
    {
      path: "/itemAttachment",
      component: ItemAttachment,
      meta: {},
    },
    {
      path: "/itemAttachment2",
      name: "itemAttachment2",
      component: ItemAttachment,
    },
    {
      path: "/manufacturers",
      component: Manufacturers,
      meta: {},
    },
  ],
};
